import { Form } from 'antd';
import './style.scss';

export default function CustomFormItem(props) {
	return <Form.Item {...props} />;
}
